import { InjectionToken } from "@angular/core";
export var CURRENCY_MASK_CONFIG = new InjectionToken("currency.mask.config");
//# sourceMappingURL=currency-mask.config.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-currency/src/currency-mask.config.js
// module id = null
// module chunks = 